import { FC, useCallback } from "react";
import { Button, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import { CategoryIcon } from "@/components/pages/dimensions/components/icons/CategoryIcon";

export type CategorySharedCostTabType = "category" | "sharedCost";

interface CategoryCostAllocationTabItemProps {
  label: string;
  count: number;
  selected: boolean;
  disabled?: boolean;
  view: CategorySharedCostTabType;
  setView(v: CategorySharedCostTabType): void;
}

export const CategoryCostAllocationTabItem: FC<
  CategoryCostAllocationTabItemProps
> = ({ selected, count, view, setView, label, disabled }) => {
  const clickHandler = useCallback(() => {
    setView(view);
  }, [setView, view]);

  return (
    <Button
      size="small"
      disabled={disabled}
      sx={{
        px: 4,
        bgcolor: selected ? "white" : undefined,
      }}
      startIcon={
        view === "category" ? (
          <CategoryIcon color="primary" fontSize="small" />
        ) : (
          <CurrencyExchangeOutlinedIcon color="primary" fontSize="small" />
        )
      }
      onClick={clickHandler}
    >
      <Typography variant="inherit">{label}</Typography>

      <Stack
        ml={1}
        width={24}
        height={24}
        borderRadius="50%"
        justifyContent="center"
        bgcolor={count ? "primary.light" : "grey.200"}
      >
        <Typography variant="inherit" fontSize={12}>
          {count}
        </Typography>
      </Stack>
    </Button>
  );
};
